import { LanguageService } from '../../LanguageService'
import { ColorModeSportNameEnum } from '../../../constants/Enums/UiEnum';
import { SportView, SportViewTypeEnum } from './enums/SportViewType';
import store from '../../..';
import { LocalStorageService } from '../../LocalStorageService';
import { SportDispatchingEventType } from './enums/SportEventType';
import SportRoutingHelper from './SportRoutingHelper';
import { Browser } from '../Browser';
import { Auth } from '../../Auth';
import { SportIntegration } from './SportIntegration';

/**
 * @namespace SportHelper 
 */
const SportHelper = {
    SPORT_DISPATCH_EVENT_NAME: 'sportAppEventListener',
    /**
     * Convert string to camel case string
     * @param {string } page Sport page name
     * @param {string } targetId Sport target id
     * @param {string } viewType Sport view type
     */
    changeRoute: (page, targetId, viewType) => {
        try {
            const sportInstance = SportHelper.getSportInstance();
            let message = SportRoutingHelper.generateRouteObject(page, targetId);
            const route = { type: SportDispatchingEventType.RouteChange, message };
            if (sportInstance?.starter) {
                sportInstance?.starter?.dispatchEvent(SportHelper.SPORT_DISPATCH_EVENT_NAME, route);

            } else if (sportWindow?.setSportAppRoute) {
                sportInstance.setSportAppRoute(route)
            }
        } catch (error) {
            console.log(error);
        }
    },
    destroy() {
        const sportInstance = SportHelper.getSportInstance();
        const event = { type: SportDispatchingEventType.Destroy, message: null };
        sportInstance?.starter?.dispatchEvent(SportHelper.SPORT_DISPATCH_EVENT_NAME, event);
    },
    themeChange: (theme) => {
        const sportInstance = SportHelper.getSportInstance();
        const event = { type: SportDispatchingEventType.ThemeChange, message: ColorModeSportNameEnum[theme] };
        sportInstance?.starter?.dispatchEvent(SportHelper.SPORT_DISPATCH_EVENT_NAME, event);
    },
    openBetSlip: (history) => {
        if (SportHelper.isSportPage()) {
            SportHelper.dispatchEvent(SportDispatchingEventType.OpenBetSlip);
        } else {
            const lang = LanguageService.getSelectedLanguage();
            history && history.push(`/${lang}/sport?betslip=open`);
        }
    },
    openMyBets: (history) => {
        const isLoggedIn = Auth.isAuthenticated();
        if (isLoggedIn && SportHelper.isSportPage()) {
            SportHelper.dispatchEvent(SportDispatchingEventType.OpenBetSlip, { betslipActiveTab: 2 });
            return
        }
        const lang = LanguageService.getSelectedLanguage();
        history && history.push(`/${lang}/sport/${!isLoggedIn ? 'popup/login/' : ''}?mybets=open`);

    },
    shouldOpenBetSlip: () => {
        let betslipState = Browser.getURLParamValue('betslip');
        return betslipState === 'open' ? true : false;
    },
    shouldOpenMyBets: () => {
        let betslipState = Browser.getURLParamValue('mybets');
        return betslipState === 'open' ? true : false;
    },
    getSportInstance: () => {
        const viewType = SportHelper.retrieveView();
        return window.sportMobileApp || window[viewType] || window?.SportFrame || window.esportApp;
    },
    dispatchEvent: (type, message = null) => {
        const sportInstance = SportHelper.getSportInstance();
        if (sportInstance?.starter) {
            sportInstance?.starter?.dispatchEvent(SportHelper.SPORT_DISPATCH_EVENT_NAME, { type, message });
        }
    },

    retrieveView() {
        const viewType = SportHelper.retrieveViewType();
        return SportView[viewType];
    },
    retrieveViewType() {
        const LAST_SELECTED_SPORTS_VIEW = "sports_view";
        //Configured default view type
        const { sportViewType } = store.getState().settings.sportSettings;
        //If view type provided via url launch sport by provided view typ
        let viewType = new URLSearchParams(window.location.search).get("view");
        //Store selected viewType on local storage
        if (viewType) {
            LocalStorageService.set(LAST_SELECTED_SPORTS_VIEW, viewType);
        }
        //If view type is not provided via URL, try to get it from local storage
        else {
            const sportsView = LocalStorageService.get(LAST_SELECTED_SPORTS_VIEW);
            viewType = sportsView ? sportsView : null;
        }
        switch (viewType) {
            case 'standard':
                return SportViewTypeEnum.Standard;
            case 'african':
                return SportViewTypeEnum.African;
            case 'latin':
                return SportViewTypeEnum.Latin;
            // case 'paper':
            //     return SportViewTypeEnum.Paper
            case 'asian':
                return SportViewTypeEnum.Asian;
            case 'modern':
                return SportViewTypeEnum.Modern;
            default:
                return sportViewType;
        }
    },
    isSportPage: () => {
        const { pathname } = window.location;
        const lang = LanguageService.getSelectedLanguage();
        return pathname.includes(`/${lang}/sport`) || pathname.includes(`/${lang}/esport`);
    },
    isNewUrlMechanismEnabled: () => {
        const viewType = SportIntegration.retrieveViewType();
        const isNewURLMechanism = viewType === SportViewTypeEnum.Latin;
        return isNewURLMechanism;
    },
    isLiveUrl: () => {
        try {
            const pathname = window?.location?.pathname;
            // Must contain /event-details/
            if (!pathname.includes("/event-details/")) {
                return false;
            }

            // Find segment starting with "flt"
            const fltSegment = pathname
                .split("/")
                .find(segment => segment.startsWith("flt"));

            if (!fltSegment) {
                return false;
            }
            // Split by "-"
            const parts = fltSegment.split("-");

            // Ensure at least 5 elements exist
            if (parts.length < 6) {
                return false;
            }

            // Check if 5th element is "1"
            return parts[5] === "1";
        } catch (e) {
            return false; // invalid URL
        }
    }
}

export default SportHelper;
